<script>
import { sumGameInit } from '../common/session_common';
import { newGame, joinGame } from '../common/game_common';
import { MAX_NUM_DEFAULT, LENGTH_DEFAULT } from '../common/constants';
let gameCode = '';
let playerName = '';
let newGameNav = true;
let maxNum = MAX_NUM_DEFAULT;
let boardLength = LENGTH_DEFAULT;
const boardLengthN = [9, 12, 15, 18, 21, 24, 27, 30];

async function newGameAct() {
  await newGame(playerName, {
    maxNum,
    boardLength,
  });  
}

async function joinGameAct() {
  await joinGame(playerName, gameCode.toUpperCase());  
}

function newGameNavSet(newGameNavVal) {
  newGameNav = newGameNavVal;  
}

function boardLengthSelect(ev) {
  boardLength = parseInt(ev.target.value);
}

sumGameInit();

</script>

<label for="playerName">player name</label>
<input type="text" class="input-line" name="playerName" bind:value={playerName} />

{#if newGameNav}
  <div class="nav-line">
    <label for="maxNum">maximum number:</label>
    <input type="text" class="maxNum" name="maxNum" bind:value={maxNum} />
  </div>
  <div class="nav-line">
    <label for="boardLength">board length:</label>
    <select on:change={boardLengthSelect}>
      {#each boardLengthN as bLength}
        {#if bLength !== boardLength}
          <option value={bLength}>{bLength}</option>
        {:else}
          <option value={bLength} selected>{bLength}</option>
        {/if}
      {/each}
    </select>
  </div>
  <button class="nav-button nav-margin" on:click={newGameAct}>NEW</button>
  <button class="nav-button" style="margin-top: 3em;" on:click={() => newGameNavSet(false)}>JOIN THE GAME</button>
{:else}
  <label for="gameCode" class="nav-margin">code</label>
  <input type="text" class="input-line gameCode" name="gameCode" bind:value={gameCode} />
  <button class="nav-button nav-margin" on:click={joinGameAct}>JOIN</button>
  <button class="nav-button" style="margin-top: 2em;" on:click={() => newGameNavSet(true)}>NEW GAME</button>
{/if}

<!-- <button class="nav-button nav-margin">LOGIN</button>
<button class="nav-button">SIGN UP</button> -->

<style>
  .nav-button {
    min-width: 40%;
  }

  .nav-margin {
    margin-top: 1em;
  }

  .nav-line {
    display: flex;
    flex-direction: row;
    min-width: 60%;
    margin-top: 0.5em;
    justify-content: space-between;
    align-items: baseline;
  }

  .input-line {
    margin-top: 0.5em;
    min-width: 20%;
  }

  select {
    margin-left: 0.5em;
    width: 3em;
    text-align: right;
  }

  option {
    text-align: right;
    direction: rtl;
  }

  .maxNum {
    width: 3em;
    margin-left: 0.5em;
  }

  .gameCode {
    text-transform: uppercase;
  }

  @media only screen and (min-width: 1000px) {
    .nav-line {
      min-width: 20%;
    }
    .nav-button {
      min-width: 10%;
    }

  }

</style>